import Vue from "vue";
import API_URL from "@/const/apiurl";

const URL = new Vue({
  data: {
    consumoSinEncaje: API_URL + "consumoSinEncaje/",
    parametrosCoac: API_URL + "cooperativas/",
    parametrosCoacAhorros: API_URL + "ahorros/",
    dummyResponse: API_URL + "dummyResponse/",
    calculoPrestamo: API_URL + "cooperativas/calculos",
    calculoAhorros: API_URL + "ahorros/calculos",
  },
});

export default URL;
